import gql from 'graphql-tag'

export default gql`
{
  labelSummary {
    group
    count
    tracking
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/labelSummary.js